import { render } from "./CookieBanner.vue?vue&type=template&id=663f36fe&ts=true"
import script from "./CookieBanner.vue?vue&type=script&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__